import { Loader2 } from 'lucide-react'

/** In-panel loading state for My Bills lists — matches WinTracker / XTimeline dashboard patterns. */
export const BillsLoading: React.FC = () => {
  return (
    <div className="mx-auto flex w-full max-w-sm flex-col items-center justify-center gap-3 py-8 font-body lg:pt-2 lg:pb-8 xl:pt-6 xl:pb-16">
      <div className="flex min-h-31 flex-col items-center justify-center gap-3">
        <Loader2 className="size-6 animate-spin text-muted-foreground" aria-hidden />
        <p className="text-sm text-muted-foreground">Loading recommendations…</p>
      </div>
    </div>
  )
}
